var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('the-sidebar'),_c('div',{staticClass:"content-wrapper"},[_c('the-header-panel',{staticClass:"w-100",attrs:{"token":_vm.token,"app":_vm.application}}),_c('router-view',{staticClass:"w-100 p-4",attrs:{"headers":_vm.headers,"token":_vm.token}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }